/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import _ from 'lodash';
import { createBEM } from 'src/util/bem';
import './tab.less';
let bem = createBEM('tab');

export interface TabPropsI {
    value?: string | number;
    dataSource: {name: string, value: string | number}[]
}

@Component
export default class Tab extends Vue.Component<TabPropsI> {
    @Prop({
        type: [String, Number],
    })
    value!: string | number;

    @Prop({
        type: Array,
    })
    dataSource!: {name: string, value: string | number}[];

    @Prop({
        type: Boolean,
        default: false,
    })
    isDataManagement!: boolean;

    click(item:{name: string, value: string | number}) {
        if(this.value === item.value) {
            return
        }
        this.$emit('input', item.value)
        this.$emit('change', item.value, item)
    }

    render(h) {
        if(!this.isDataManagement){
            return <div class={bem()} >
            {
                this.dataSource.map(i=> <div onClick={this.click.bind(this, i)} key={i.value} class={bem('item', {active: this.value===i.value})}>
                    {i.name}
                </div>)
            }
        </div>;
        }
        else{
            return <div class={bem()} style="float: right; margin-left: 15px;">
            {
                this.dataSource.map(i=> <div onClick={this.click.bind(this, i)} key={i.value} class={bem('item', {active: this.value===i.value})}>
                    {i.name}
                </div>)
            }
        </div>;
        }
    }
}
